import { db } from './firebase';
import { doc, getDoc, setDoc, serverTimestamp, collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { auth } from './firebase';

const settingsService = {
  async get() {
    try {
      if (!auth.currentUser) {
        throw new Error('User not authenticated');
      }

      const userId = auth.currentUser.uid;
      const settingsRef = doc(db, `users/${userId}/settings/default`);
      const settingsSnap = await getDoc(settingsRef);
      
      if (settingsSnap.exists()) {
        return { data: settingsSnap.data() };
      } else {
        // Impostazioni predefinite
        const defaultSettings = {
          companyName: '',
          address: '',
          phone: '',
          warrantyDays: 30,
          receiptWidth: '58mm',
          disclaimer: 'Grazie per averci scelto',
          websiteUrl: window.location.origin,
          startingReceiptNumber: 1,
          currentReceiptNumber: 1,
          autoPrint: true,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
          language: 'it',
          currency: 'EUR',
          printerType: 'thermal', // Opzione per il tipo di stampante (thermal o a4)
          printDuplicate: false,   // Opzione per stampare in duplice copia
          showVAT: false,         // Opzione per mostrare l'IVA sulla ricevuta
          vatPercentage: 22       // Percentuale IVA predefinita (22% in Italia)
        };
        
        // Salva le impostazioni predefinite
        await setDoc(settingsRef, defaultSettings);
        return { data: defaultSettings };
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw new Error('Errore nel recupero delle impostazioni: ' + error.message);
    }
  },

  async update(settings) {
    try {
      if (!auth.currentUser) {
        throw new Error('User not authenticated');
      }

      const userId = auth.currentUser.uid;
      const settingsRef = doc(db, `users/${userId}/settings/default`);
      
      const updatedSettings = {
        ...settings,
        updatedAt: serverTimestamp()
      };
      
      await setDoc(settingsRef, updatedSettings, { merge: true });
      return { data: updatedSettings };
    } catch (error) {
      console.error('Error updating settings:', error);
      throw new Error('Errore nell\'aggiornamento delle impostazioni: ' + error.message);
    }
  },

  async incrementReceiptNumber() {
    try {
      const userId = auth.currentUser.uid;
      const settingsRef = doc(db, `users/${userId}/settings/default`);
      const settingsSnap = await getDoc(settingsRef);
      
      if (settingsSnap.exists()) {
        const settings = settingsSnap.data();
        const updatedSettings = {
          ...settings,
          currentReceiptNumber: (settings.currentReceiptNumber || 1) + 1
        };
        await setDoc(settingsRef, updatedSettings);
        return { data: updatedSettings };
      }
      throw new Error('Settings not found');
    } catch (error) {
      console.error('Error incrementing receipt number:', error);
      throw error;
    }
  },

  async resetReceiptNumber() {
    try {
      const userId = auth.currentUser.uid;
      const settingsRef = doc(db, `users/${userId}/settings/default`);
      const settingsSnap = await getDoc(settingsRef);
      
      if (settingsSnap.exists()) {
        const settings = settingsSnap.data();
        const updatedSettings = {
          ...settings,
          currentReceiptNumber: settings.startingReceiptNumber || 1
        };
        await setDoc(settingsRef, updatedSettings);
        return { data: updatedSettings };
      }
      throw new Error('Settings not found');
    } catch (error) {
      console.error('Error resetting receipt number:', error);
      throw error;
    }
  },

  async getMaxRepairNumber() {
    try {
      const userId = auth.currentUser.uid;
      
      // Crea una query per ottenere il dispositivo con il numero di riparazione più alto
      const devicesRef = collection(db, `users/${userId}/devices`);
      const q = query(devicesRef, orderBy('repairNumber', 'desc'), limit(1));
      
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        // Prendi il primo (e unico) documento dalla query
        const maxDevice = querySnapshot.docs[0].data();
        return maxDevice.repairNumber;
      }
      
      // Se non ci sono dispositivi, restituisci 0
      return 0;
    } catch (error) {
      console.error('Errore nel recupero del numero massimo di riparazione:', error);
      return 0;
    }
  }
};

export default settingsService; 